var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4.797c1.517-.311 2.67-.33 3.626-.21 1.119.139 2.018.472 3.023.85l.03.01c.987.37 2.08.78 3.447.952 1.104.138 2.355.117 3.874-.16v8.964c-1.517.312-2.67.33-3.626.211-1.119-.14-2.018-.473-3.023-.85l-.03-.011c-.987-.37-2.08-.78-3.447-.952-1.104-.138-2.355-.117-3.874.16zm14.758-.767c-1.9.475-3.275.523-4.384.384-1.119-.14-2.018-.473-3.023-.85l-.03-.012c-.987-.37-2.08-.78-3.447-.95-1.387-.174-3.006-.098-5.096.423A1 1 0 0 0 3 4v17a1 1 0 1 0 2 0v-5.203c1.517-.311 2.67-.33 3.626-.21 1.119.139 2.018.472 3.023.85l.03.01c.987.37 2.08.78 3.447.952 1.391.174 3.017.096 5.117-.429A1 1 0 0 0 21 16V5a1 1 0 0 0-1.242-.97",
    clipRule: "evenodd"
  })));
};
export default SvgFlag;